
import PropTypes from 'prop-types';
import { useState, useCallback , useEffect} from 'react';
import { useSelector } from 'react-redux';
import { Container, useTheme, TableContainer, Card, Table, TableBody, Button, Tabs, Tab, alpha, Dialog, Box, DialogActions} from '@mui/material';
import { useSettingsContext } from '../../../components/settings/index.js';
import {useTable, TableHeadCustom_1, TablePaginationCustom} from 'src/components/table/index.js';
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/index.js';
import {RouterLink} from '../../../routes/components/index.js';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSnackbar } from '../../../components/snackbar/index.js';
import Iconify from '../../../components/iconify/iconify.js';
import AuditingTableRow from './auditing-table-row.js';
import AuditingToolBar from './auditing-toolbar.js';
import Label from '../../../components/label/index.js';
import Scrollbar from 'src/components/scrollbar/scrollbar.js';
import { useBoolean } from '../../../hooks/use-boolean.js';
import { PDFViewer } from '@react-pdf/renderer';
import AuditingPDFView from './auditing-pdf.js'
import { staticForm1, staticForm2, appraisalForm, consolidatedForm, trainerCompetencies, assessorCompetencies } from 'src/util/formCategory.js';

import AuditingFormDialog from './create-auditing-form.js';


// GRAPHQL
import {GET_AUDITINGFORM, GET_APPRAISALDETAILS, GET_CONSOLIDATEDDETAILS, CREATE_AUDITINGFORM, DELETE_AUDITINGFORM, UPDATE_AUDITINGFORM} from '../../../graphql/modules/_client/auditingForm.js';
import { useQuery, useMutation , useLazyQuery} from "@apollo/react-hooks";

const STATUS_OPTION = [
  {value: 'all', label: 'All'},
]
// const TABLE_HEAD = [
//   {id: 'tsgRefNumber', label: 'TGS Course Reference Number'},
//   {id: 'courseTitle', label: 'Course Title'},
//   {id: 'modeOfTraining', label: 'Mode of Training'},
//   {id: 'mediumInstruction', label: 'Medium of Instruction'},
//   {id: 'approvalDate', label: 'Valid From (Date)'},
//   {id: 'validUntil', label: 'Valid To (Date)'},
//   {}
// ]

// const defaultFilters = {
//   name: '',
//   subscription: [],
//   status: 'all'
// }

export function AuditingListView({formInfo}) {
  const fullName = useSelector((state) => state?.auth?.user?.fullName);
  const company  = useSelector((state) => state?.auth?.company);
  const [isCreate, setCreate] = useState(true);
  const [dataToUpdate, setDataToUpdate] = useState(null);
  const [status, setStatus] = useState('draft');
  const [idToUpdate, setIdToUpdate] = useState("");
  const {companyName, databaseName}  = useSelector((state) => state?.auth?.companyProfile?.companyProfile);
  const companyProfile = useSelector((state) => state?.auth?.companyProfile?.companyProfile);
  const [tableHead, setTableHead] = useState([])
  const [dataField, setDataField] = useState(() => state?.data?.section || []);
  const { state } = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();
  const table = useTable();
  // const navigate = useNavigate();
  const settings = useSettingsContext();
  const [filters, setFilters] = useState('all');
  const [searchText, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [results, setResults] = useState(null);
  const [auditingForm, setAuditingForm] = useState(null);
  const [dateReviewStart, setDatereviewStart] = useState(null);
 const [fullNameTrTa, setFullNameTrTa] = useState('');

  const confirm = useBoolean();
  const onPrint = useBoolean();

  const [CreateAuditingFormMutation] =  useMutation(CREATE_AUDITINGFORM);
  const [UpdateAuditingFormMutation] =  useMutation(UPDATE_AUDITINGFORM);
  const [DeleteAuditingFormMutation] =  useMutation(DELETE_AUDITINGFORM);

  const isStaticForm = state?.data?._id === staticForm1 || state?.data?._id === staticForm2 ? true : false;
  

  const { data, loading, error, refetch } = useQuery(GET_AUDITINGFORM, {
    variables: {
      limit: table?.rowsPerPage,
      offset: table?.page,
      searchText: searchText,
      companyName: state?.databaseName || company,
      formModel: state?.data?.formModel,
      order: table.order || 'asc',
      orderBy: table.orderBy || 'courseTitle',
      },
      fetchPolicy: "cache-and-network",
  });

const [getAppraisalDetails, { dataAppraisal, loadingAppraisal }] = useLazyQuery(GET_APPRAISALDETAILS);
const [getConsolidatedDetails, { dataConsolidated, loadingConsolidated }] = useLazyQuery(GET_CONSOLIDATEDDETAILS);
    // const {data: dataAppraisal, refetch: refetchAppriasal} = useLazyQuery(GET_APPRAISALDETAILS, {
    // variables: {
    //   nameOfStaff: "BRYAN TRAINER",
    //   companyName: state?.databaseName || company,
    //   datereview: {
    //         dateFrom: null,
    //         dateTo: null
    //   }, 
    //   },
    //   fetchPolicy: "cache-and-network",
    // });




    useEffect(() => {
      // const _dataField = state?.data?.section?.flatMap(s => s.components);
      const components = state?.data?.section?.flatMap(s => s.components).filter(item => item?.showIntable);
      setTableHead(components?.sort((a, b) => Number(a?.hPosition) - Number(b?.hPosition)))

      if (state?.data?.section) {
        setDataField(state.data.section);
      }

      if(data){
        setResults(data?.getAuditingForm)
      }
  }, [data, state?.data?.section, dataToUpdate])




  // const handleChangeText = useCallback((event) => {
  //   const { name, value } = event.target;
  //   setDataField(prevFields => {
  //     return prevFields.map(field => 
  //       field.name === name ? { ...field, value } : field
  //   );
  //   })
  // })

  const handleChangeText = useCallback((sectionName, fieldName, value) => {
    setDataToUpdate(prev => ({
      ...prev,
      [sectionName]: {
        ...(prev?.[sectionName] ?? {}), 
        [fieldName]: value
      }
    }));

    // The is for Appraisal to get other forms details
    if(state?.data?._id === appraisalForm && fieldName === 'reviewStartDate'){
      setDatereviewStart(value)
    }
     if(state?.data?._id === appraisalForm && fieldName === 'reviewEndDate'){
      HandleQueryAppraisalDetails(value);
     }

    if(state?.data?._id === consolidatedForm && fieldName === 'reviewStartDate'){
      setDatereviewStart(value)
    }
     if(state?.data?._id === consolidatedForm && fieldName === 'reviewEndDate'){
      HandleQueryConsolidatedDetails(value);
     }




    
  });
  
  
  

  const handleFilters = useCallback((name, value) => {
      setSearch(value)
    },
    [table]
  );
  

    const handleFilterStatus = useCallback(
      (event, newValue) => {
        if(newValue !== "all"){
          setFilters(newValue);
          setSearch(newValue);
        }else {
          setFilters(newValue);
          setSearch('');
        }

      },
      [table]
    );


   const handleSave = async(fstatus) => {
     try {
       if(dataToUpdate?.section?.length === 0 || !dataToUpdate?.section){
         enqueueSnackbar('Failed to save blank form.', {variant: 'error'});
       }else {
        const {data: { createAuditingForm }} = await CreateAuditingFormMutation({
         variables: {
           companyName: databaseName,
           fullName: fullName,
           formModel: state?.data?.formModel,
             data: {
               section: dataToUpdate?.section,
               status: fstatus,
               createdBy: fullName,
               createdDate: new Date(),
               modifiedBy: fullName,
               modifiedDate: new Date()
             }
           }
       })
       if(createAuditingForm?.success){
         enqueueSnackbar('Create success!', {variant: 'success'});
         refetch();
       }else {
         enqueueSnackbar('Failed to created', {variant: 'error'});
       }
       }

 
     } catch(err){
       console.log(err)
     }
   }

  const handleDeleteRow = useCallback(async (id) => {
       const {data: { deleteAuditingForm }} = await DeleteAuditingFormMutation({
         variables: {
           _id: id,
           formModel: state?.data?.formModel,
           companyName: databaseName,
           fullName: fullName,
         }
       })
   
       if(deleteAuditingForm?.success){
         enqueueSnackbar('Delete success!', {variant: 'success'});
         refetch();
       }else {
         enqueueSnackbar('Failed to delete!', {variant: 'error'});
       }
       },
       [refetch]
  );

  const handleUpdate = async(fstatus) => {
     try {
       const {data: { updateAuditingForm }} = await UpdateAuditingFormMutation({
         variables: {
           _id: idToUpdate,
           companyName: databaseName,
           fullName: fullName,
           formModel: state?.data?.formModel,
             data: {
               section: dataToUpdate?.section,
               status: fstatus,
               modifiedBy: fullName,
               modifiedDate: new Date()
             }
           }
       })
       if(updateAuditingForm?.success){
         enqueueSnackbar('Update success!', {variant: 'success'});
         refetch();
       }else {
         enqueueSnackbar('Failed to created', {variant: 'error'});
       }
 
     } catch(err){
       console.log(err)
     }
   }
   const handleViewAuditingForm = useCallback((row) => {
     setAuditingForm(row);
     onPrint.onTrue();
   },
   []
   );

  const handleCompleted = async(_id, completed) => {
      try {
       const {data: { updateAuditingForm }} = await UpdateAuditingFormMutation({
         variables: {
           _id: _id,
           companyName: databaseName,
           fullName: fullName,
           formModel: state?.data?.formModel,
             data: {
               section: dataToUpdate?.section,
               status: completed,
               modifiedBy: fullName,
               modifiedDate: new Date()
             }
           }
       })
       if(updateAuditingForm?.success){
         enqueueSnackbar('Form is now Completed.', {variant: 'success'});
         refetch();
       }else {
         enqueueSnackbar('Failed to created', {variant: 'error'});
       }
     } catch(err){
       console.log(err)
     }
   };

  const handleArchive = async(_id, archive) => {
      try {
       const {data: { updateAuditingForm }} = await UpdateAuditingFormMutation({
         variables: {
           _id: _id,
           companyName: databaseName,
           fullName: fullName,
           formModel: state?.data?.formModel,
             data: {
               section: dataToUpdate?.section,
               status: archive
             }
           }
       })
       if(updateAuditingForm?.success){
         enqueueSnackbar('Form is now Archived.', {variant: 'success'});
         refetch();
       }else {
         enqueueSnackbar('Failed to created', {variant: 'error'});
       }
     } catch(err){
       console.log(err)
     }
  };

  const handleInProgress = async(_id, inprogress) => {
      try {
       const {data: { updateAuditingForm }} = await UpdateAuditingFormMutation({
         variables: {
           _id: _id,
           companyName: databaseName,
           fullName: fullName,
           formModel: state?.data?.formModel,
             data: {
               section: dataToUpdate?.section,
               status: inprogress,
               modifiedBy: fullName,
               modifiedDate: new Date()
             }
           }
       })
       if(updateAuditingForm?.success){
         enqueueSnackbar('Form is now In-Progress.', {variant: 'success'});
         refetch();
       }else {
         enqueueSnackbar('Failed to created', {variant: 'error'});
       }
     } catch(err){
       console.log(err)
     }
  };

  const handledCancelled = async(_id, cancelled) => {
      try {
       const {data: { updateAuditingForm }} = await UpdateAuditingFormMutation({
         variables: {
           _id: _id,
           companyName: databaseName,
           fullName: fullName,
           formModel: state?.data?.formModel,
             data: {
               section: dataToUpdate?.section,
               status: cancelled,
               modifiedBy: fullName,
               modifiedDate: new Date()
             }
           }
       })
       if(updateAuditingForm?.success){
         enqueueSnackbar('Form is now Cancelled.', {variant: 'success'});
         refetch();
       }else {
         enqueueSnackbar('Failed to created', {variant: 'error'});
       }
     } catch(err){
       console.log(err)
     }
  };


  const excutedFind = useCallback((e) => {
    if(state?.data?._id === appraisalForm){
      setDataToUpdate(prev => ({
      ...prev,
      ['section']: {
        ...(prev?.['section'] ?? {}),
        ['nameOfStaff']: e.fullName
      }
    }));
    setFullNameTrTa(e.fullName)
    }else if(state?.data?._id === consolidatedForm) {
    setDataToUpdate(prev => ({
      ...prev,
      ['section']: {
        ...(prev?.['section'] ?? {}),
        ['courseTitle']: e.courseTitle
      }
    }));
      setFullNameTrTa(e.courseTitle)
    }else if(state?.data?._id === trainerCompetencies) {
    setDataToUpdate(prev => ({
      ...prev,
      ['section']: {
        ...(prev?.['section'] ?? {}),
        ['nameOfTrainer']: e.fullName
      }
    }));
      setFullNameTrTa(e.fullName)
    }else if(state?.data?._id === assessorCompetencies) {
    setDataToUpdate(prev => ({
      ...prev,
      ['section']: {
        ...(prev?.['section'] ?? {}),
        ['nameOfAssessor']: e.fullName
      }
    }));
      setFullNameTrTa(e.fullName)
    }
  });

 


  const HandleQueryAppraisalDetails = async(reviewDateEnd) => {
    const {data} =   await getAppraisalDetails({
    variables: {
      nameOfTrainer: fullNameTrTa,
      companyName: state?.databaseName || company,
      datereview: { dateFrom: dateReviewStart || null, dateTo: reviewDateEnd || null },
    },
  });
   const app_result = data?.getPerformanceAppraisal;
    setDataToUpdate(prev => ({
      ...prev,
      ['section']: {
        ...(prev?.['section'] ?? {}), 
        ['competency2']: `${app_result?.competencies}`,
        ['competency3']: `${app_result?.passingrate}`
      }
    }));
      
  }

    const HandleQueryConsolidatedDetails = async(reviewDateEnd) => {
    const {data} =   await getConsolidatedDetails({
    variables: {
      courseTitle: fullNameTrTa,
      companyName: state?.databaseName || company,
      datereview: { dateFrom: dateReviewStart || null, dateTo: reviewDateEnd || null },
    },
  });
   const app_result = data?.getConsolidatedPassingRate;

    setDataToUpdate(prev => {
    const updatedSection = { ...(prev?.section ?? {}) };

      app_result?.consolidated?.forEach((item, index) => {
        const i = index + 1; // for assessor1, assessor2, assessor3...
        updatedSection[`assessor${i}Name`] = item.createdBy;
        updatedSection[`assessor${i}Asst`] = item.conducted;
        updatedSection[`assessor${i}Competent`] = item.pass;
        updatedSection[`assessor${i}NYC`] = item.failed;
        updatedSection[`assessor${i}PassingRate`] = item.passingRate;
      });

      return {
        ...prev,
        section: updatedSection,
      };
    });
      
  }




  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
        <CustomBreadcrumbs
         heading={`${companyName} - ${state?.data?.title}`}
         links={[
          {name: 'Dashboard'},
          {name: 'Auditing Forms'}
         ]}
         action ={
          <Button
          componet={RouterLink}
          onClick={() => {
            setDataToUpdate(null)
            setCreate(true);
            confirm.onTrue()
          }}
          variant="contained"
          startIcon={<Iconify icon="mingcure:add-line" />}
          >
            Create
          </Button>
         }
        />


        <Card>
         <Tabs 
          value={filters}
          onChange={handleFilterStatus}
          sx={{
            px: 2.5,
            boxShadow: (theme) => `inset 0 -2px 0 0 ${alpha(theme.palette.grey[500], 0.08)}`
          }}
         >
          {STATUS_OPTION.map((tab) => (
            <Tab
              key={tab?.value}
              iconPosition='end'
              value={tab?.value}
              label={tab?.label}
              icon={
              <Label 
                variant={
                  ((tab.value === 'all' || tab.value === filters.status) && 'filled') || 'soft'
                }
                >
                  {tab.value === 'all' && results?.count}
              </Label>
              }
           />
  
          ))}

         </Tabs>

          <AuditingToolBar onFilters={handleFilters} />
        <Scrollbar>

          <TableContainer sx={{ position: 'relative', overflow: 'unset'}}>
              <Table  sx={{minWidth: 960}}>
              {tableHead && (
                    <TableHeadCustom_1
                    headLabel={[...tableHead, 
                      ...(isStaticForm
                    ? [{ value: 'computation', label: 'Average Score' }]
                    : []),
                    
                      { "value": "status", "label": "Status" },{ "value": "action", "label": "Action" }]}
                    order={table.order}
                    orderBy={table.orderBy}
                    onSort={table.onSort}
                  />
                )}
          
   
                <TableBody>

                {results?.results?.map((row) => (
                      <AuditingTableRow
                      key={row?.id}
                      row={row}
                      tableHead={tableHead}
                      onDeleteRow={() => handleDeleteRow(row._id)}
                      onEditRow={() => {
                        setDataToUpdate(row)
                        setIdToUpdate(row?._id)
                        setCreate(false);
                        confirm.onTrue()
                      }}
                      onCancelled={() => handledCancelled(row?._id, 'Cancelled')}
                      onViewRow={() => handleViewAuditingForm(row)}
                      formId={state?.data?._id} 
                      onArchive={() => handleArchive(row?._id, 'Archived')}
                      onComplete={() => handleCompleted(row?._id, 'Completed')}
                      revertInProgress={()=>handleInProgress(row?._id, 'In-Progress')}
                    />
                ))}
                </TableBody>

              </Table>
          </TableContainer>
          </Scrollbar>

          <TablePaginationCustom 
            count={results?.count}
            page={table.page}
            rowsPerPage={table.rowsPerPage}
            onPageChange={table.onChangePage}
            onRowsPerPageChange={table.onChangeRowsPerPage}
          />
 
        </Card>

        <AuditingFormDialog
            open={confirm.value}
            onClose={confirm.onFalse}
            title={isCreate ? `Create ${state?.data?.title}` : `Update ${state?.data?.title}`}
            section={dataField}
            isCreate={isCreate}
            handleChange={handleChangeText}
            dataToUpdate={dataToUpdate}
            onFindFullName={(e) => excutedFind(e)}
            formId={state?.data?._id}
            action={
              <>
            <Button variant="contained" color="info" onClick={() => {
              handleSave('In-Progress');
            }}>
                Save
             </Button>

            <Button variant="contained" color="info" onClick={() => {
              handleSave('Draft');
            }}>
                Save as Draft
             </Button>
             </>
            }
            actionUpdate={
            <>
            <Button variant="contained" color="info" onClick={() => {
              handleUpdate('In-Progress');
            }}>
                 Update
             </Button>

            <Button variant="contained" color="info" onClick={() => {
              handleUpdate('Draft');
            }}>
                 Update as Draft
             </Button>
            </>
             }
        />
          <Dialog fullScreen open={onPrint.value}>
                <Box sx={{ height: 1, display: 'flex', flexDirection: 'column' }}>
                  <DialogActions
                    sx={{
                      p: 1.5,
                    }}
                  >
                    <Button color="inherit" variant="contained" onClick={onPrint.onFalse}>
                      Close
                    </Button>
                  </DialogActions>
        
                  <Box sx={{ flexGrow: 1, height: 1, overflow: 'hidden' }}>
                    <PDFViewer width="100%" height="100%" style={{ border: 'none' }}>
                      <AuditingPDFView auditingForm={auditingForm} companyProfile={companyProfile} data={dataField} orientation={state?.data?.orientation}/>
                    </PDFViewer>
                  </Box>
                </Box>
          </Dialog>



        

    </Container>
  );
}

AuditingListView.propTypes = {
    formInfo: PropTypes.object,
};